// extracted by mini-css-extract-plugin
export default {"BoldPlayer":"P0T0D1","boldPlayer":"P0T0D1","mediaButton":"roZxsq","icon":"XbCmQ9","pausing":"rkDOT1","playing":"FcQZMU"};